import styles from './Video.module.css';

export default function Video(props) {

  return (<div className={styles.video} style={{backgroundImage: "url("+ props.bg +")"}}>


      <a href={props.href} target="_blank" nofollow className={styles.playBtn} style={{backgroundColor: props.btnColor}}>
        <i class="fa fa-play" aria-hidden="true"></i>
      </a>
    </div>);

}
